


















































































































/**
 * @copyright       Palace Resorts
 * @description     Pantalla principal para terminos y condiciones
 * @author          Leticia Beltran
 * @creationDate    10/Agosto/2021
 */
import i18nMessages from "./i18n/messages";
import ResponseData from "@/models/store/ProveedoresTypesData";
import dataService from "@/services/proveedoresAPI";
import dataTableContract from "@/components/DatatableContract/DatatableContractList.vue";
import BreadcrumbNav from "@/components/Breadcrumbs/BreadcrumbNav.vue";
import GlobalMixin from "@/mixins/global";
export default GlobalMixin.extend({
  // Asignamos los mensajes del módulo al framework i18n, para el manejo del idioma
  i18n: i18nMessages,
  components: {
    dataTableContract,
    BreadcrumbNav,
  },
  data: () => ({
    //Data proveedores
    person: null as any,
    personOptions: [] as any,
    orderSearch: "",
    loadingPersons: false,
    descriptionLimit: 60,
    search: "",
    // Data sociedad
    company: [],
    chooseCompany: "",
    statusSelect: "" as string | string[] | object,
    status: [
      { name: "Inactivo - eliminado", id: 0 },
      { name: "Activo - Pendiente a ser autorizado", id: 1 },
      { name: "Autorizado", id: 2 },
      { name: "Rechazado", id: 3 },
      { name: "Cancelado por el SAT", id: 4 },
    ],
    isLoading: false,
  }),
  methods: {
    async getdata(val: any) {
      dataService
        .getAllProvider(0, 10, val)
        .then((Response: ResponseData) => {
          this.personOptions = Response.data.data[0].data[0];
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => (this.isLoading = false));
    },
    filterFuncion(item: any, queryText: any, itemText: any) {
      return (
        item.userID.toLowerCase().includes(queryText.toLowerCase()) ||
        item.userName.toLowerCase().includes(queryText.toLowerCase())
      );
    },
    filterSociedad(item: any, queryText: any, itemText: any) {
      return (
        item.empresaClave.toLowerCase().includes(queryText.toLowerCase()) ||
        item.empresaRazonSocial.toLowerCase().includes(queryText.toLowerCase())
      );
    },
    getProvider() {
      dataService.getCompany().then((Response: ResponseData) => {
        this.company = Response.data.data[0];
      });
    },
  },
  watch: {
    search(val: string) {
      // Items have already been requested
      if (this.isLoading) return;
      this.isLoading = true;
      this.getdata(val);
    },
  },
  mounted() {
    let autorizador = ["1", "2"].includes(this.$store.getters["auth/rol"]);
    if (autorizador) {
        this.statusSelect = this.status[1];
      }
    this.getProvider();
  },
});
